import React from 'react'
import Layout from '../../components/Layout'

const ProductsPage = () => {
    return (
        <React.Fragment>
            ProductsPage
        </React.Fragment>
    )
}

export default ProductsPage
